module.exports = __webpack_public_path__ + "static/media/fire-theft-icon.b491a598.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/fire-theft-icon.png
// module id = 1254
// module chunks = 0